/**
 * This file is auto-generated from DatePickerCalendarContent.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const today: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'Today';
        case 'pl':
            return 'Dzisiaj';
    }
};
